/* TPC custom sections — shared behaviour: welcome popups (A simple / B quiz), glow hero, try-it demos, Pal-day add. */
(function () {
  if (window.__tpcUI) return;
  window.__tpcUI = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var mark = function (s) { return esc(s).replace(/\*([^*]+)\*/g, '<u>$1</u>'); };
  var ls = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* =====================================================================
     1. Popups
     ===================================================================== */
  var cfgEl = document.getElementById('tpc-popups-config');
  var CFG = null;
  try { CFG = cfgEl ? JSON.parse(cfgEl.textContent) : null; } catch (e) { CFG = null; }

  var ov = null, teaser = null, Q = {}, current = null;
  var K = { variant: 'tpc_pop_variant', closed: 'tpc_pop_closed_at', done: 'tpc_pop_done', pending: 'tpc_pop_pending' };

  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  function ensureOverlay() {
    if (ov) return ov;
    ov = document.createElement('div');
    ov.className = 'tpc tpc-ov'; ov.hidden = true;
    ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', 'Welcome offer');
    ov.addEventListener('click', function (e) { if (e.target === ov) closePop(true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ov && !ov.hidden) closePop(true); });
    document.body.appendChild(ov);
    return ov;
  }
  function card(html, photoOnPhone) {
    ensureOverlay();
    /* Desktop: landscape card, photo on the left for every step. Phone: portrait card, photo only on the steps that ask for it. */
    var src = CFG ? (current === 'a' ? CFG.a.img : CFG.b.img) : '';
    var media = src ? '<div class="tpc-pc__media' + (current === 'a' ? ' tpc-pc__media--tall' : '') + (photoOnPhone ? '' : ' tpc-pc__media--deskonly') + '"><img src="' + esc(src) + '" alt=""></div>' : '';
    ov.innerHTML = '<div class="tpc-pc' + (src ? ' tpc-pc--wide' : '') + '"><button class="tpc-x" type="button" aria-label="Close">&times;</button>' + media + '<div class="tpc-pc__main">' + html + '</div></div>';
    $('.tpc-x', ov).onclick = function () { closePop(true); };
    if (ov.hidden) {
      ov.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { ov.classList.add('is-in'); });
    }
    if (teaser) teaser.hidden = true;
  }
  function closePop(userClosed) {
    if (!ov || ov.hidden) return;
    ov.classList.remove('is-in');
    document.documentElement.style.overflow = '';
    setTimeout(function () { ov.hidden = true; ov.innerHTML = ''; }, 250);
    if (userClosed && !ls.get(K.done)) ls.set(K.closed, String(Date.now()));
    if (userClosed && current === 'b' && CFG && CFG.teaser && !ls.get(K.done)) showTeaser();
  }
  function showTeaser() {
    if (!teaser) {
      teaser = document.createElement('button');
      teaser.type = 'button'; teaser.className = 'tpc tpc-teaser';
      teaser.textContent = CFG.teaser;
      teaser.onclick = function () { openB(); };
      document.body.appendChild(teaser);
    }
    teaser.hidden = false;
  }
  function copyBtn(code) {
    var b = $('[data-tpc-copy]', ov); if (!b) return;
    b.onclick = function () {
      try { navigator.clipboard.writeText(code); } catch (e) {}
      b.textContent = 'Copied';
    };
  }
  function discountUrl(code, to) {
    return code ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(to || '/') : (to || '/');
  }

  /* Subscribe through the theme's own customer form so Shopify's tokens and bot checks apply. */
  function subscribe(email, tags, pending) {
    var form = document.getElementById('tpc-pop-form');
    if (!form) return Promise.resolve(true);
    form.querySelector('[name="contact[email]"]').value = email;
    form.querySelector('[name="contact[tags]"]').value = tags.join(',');
    ls.set(K.pending, JSON.stringify(pending));
    return fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
      .then(function (res) {
        if (res.url && res.url.indexOf('challenge') > -1) { form.submit(); return false; }   // captcha: fall back to a normal post, we resume after reload
        ls.del(K.pending); return true;
      })
      .catch(function () { form.submit(); return false; });
  }

  /* ---- A: simple ---- */
  function openA() {
    if (!CFG) return; current = 'a';
    var a = CFG.a;
    card('<form class="tpc-pb' + (a.img ? '' : ' tpc-pb--top') + '" id="tpc-fa" novalidate><div class="tpc-eyebrow">' + esc(a.eyebrow) + '</div><h2 class="tpc-pt">' + mark(a.title) + '</h2><p class="tpc-px">' + esc(a.text) + '</p>' +
      '<input class="tpc-inp" id="tpc-a-email" type="email" autocomplete="email" placeholder="Enter your email address" aria-label="Email address" required>' +
      '<p class="tpc-err" id="tpc-a-err" hidden>Please enter a valid email address.</p>' +
      '<button class="tpc-btn tpc-btn--full" type="submit">' + esc(a.btn) + '</button><p class="tpc-fine">' + esc(CFG.fine) + '</p></form>', true);
    track('tpc_popup_view', { variant: 'a' });
    $('#tpc-fa', ov).onsubmit = function (e) {
      e.preventDefault();
      var input = $('#tpc-a-email', ov);
      if (!input.checkValidity() || !input.value) { $('#tpc-a-err', ov).hidden = false; input.focus(); return; }
      var btn = $('button[type=submit]', ov); btn.disabled = true;
      subscribe(input.value, ['newsletter', 'popup-a'], { v: 'a' }).then(function (ok) { if (ok) successA(); });
    };
  }
  function successA() {
    current = 'a'; ls.set(K.done, '1');
    var a = CFG.a;
    card('<div class="tpc-pb' + (a.img ? '' : ' tpc-pb--top') + '"><div class="tpc-eyebrow">You\'re in</div><h2 class="tpc-pt">' + mark(a.okTitle) + '</h2><p class="tpc-px">' + esc(a.okText) + '</p>' +
      (a.code ? '<div class="tpc-code"><span>' + esc(a.code) + '</span><button type="button" data-tpc-copy>Copy code</button></div>' : '') +
      '<a class="tpc-btn tpc-btn--full" href="' + esc(discountUrl(a.code, a.shopUrl)) + '">' + esc(a.shopLabel) + '</a></div>', true);
    copyBtn(a.code); track('tpc_popup_subscribe', { variant: 'a' });
  }

  /* ---- B: quiz ---- */
  function prog(n) { var s = '<div class="tpc-prog">'; for (var i = 1; i <= 4; i++) s += '<i class="' + (i <= n ? 'is-on' : '') + '"></i>'; return s + '</div>'; }
  function openB(step) {
    if (!CFG) return; current = 'b'; Q = {};
    CFG.b.animals.forEach(function (x) { if (x.img) { var i = new Image(); i.src = x.img; } });   // warm the picture choices
    stepB(step || 'intro'); track('tpc_popup_view', { variant: 'b' });
  }
  function choice(n, back, title, cls, opts, pick) {
    card(prog(n) + '<div class="tpc-pb"><button class="tpc-back" type="button">&larr; Back</button><h2 class="tpc-pt">' + title + '</h2><div class="tpc-choices ' + cls + '">' +
      opts.map(function (o) { return '<button class="tpc-ch' + (o.img ? ' tpc-ch--pic' : '') + '" type="button" data-v="' + esc(o.v) + '">' + (o.img ? '<img src="' + esc(o.img) + '" alt="">' : '') + esc(o.t) + (o.s ? '<small>' + esc(o.s) + '</small>' : '') + '</button>'; }).join('') + '</div></div>');
    $('.tpc-back', ov).onclick = function () { stepB(back); };
    $$('[data-v]', ov).forEach(function (b) { b.onclick = function () { pick(b.dataset.v); }; });
  }
  function stepB(s) {
    var b = CFG.b, name = Q.name ? esc(Q.name) : '';
    if (s === 'intro') {
      card('<div class="tpc-pb' + (b.img ? '' : ' tpc-pb--top') + '"><div class="tpc-eyebrow">' + esc(b.eyebrow) + '</div><h2 class="tpc-pt">' + mark(b.title) + '</h2><p class="tpc-px">' + esc(b.text) + '</p>' +
        '<div class="tpc-chips"><span style="background:#ffe9b0;--r:-2deg">' + esc(b.types.bed.type) + '</span><span style="background:#e6dbff;--r:1.5deg">' + esc(b.types.feel.type) + '</span><span style="background:#cfe9ff;--r:-1deg">' + esc(b.types.trans.type) + '</span><span style="background:#d5f3e4;--r:2deg">' + esc(b.types.focus.type) + '</span></div>' +
        '<button class="tpc-btn tpc-btn--full" type="button" id="tpc-go">' + esc(b.btn) + '</button></div>', true);
      $('#tpc-go', ov).onclick = function () { stepB('name'); };
    }
    if (s === 'name') {
      /* The child's name only personalises the copy on screen. It is never sent anywhere. */
      card(prog(1) + '<form class="tpc-pb" id="tpc-fn"><h2 class="tpc-pt">Who is this Pal for?</h2><p class="tpc-px">First name only. Skip it if you like.</p><input class="tpc-inp" id="tpc-b-name" maxlength="20" autocomplete="off" placeholder="Kid\'s first name (optional)" aria-label="Kid\'s first name" value="' + name + '"><button class="tpc-btn tpc-btn--full" type="submit">Next</button></form>');
      $('#tpc-fn', ov).onsubmit = function (e) { e.preventDefault(); Q.name = $('#tpc-b-name', ov).value.trim(); stepB('age'); };
    }
    if (s === 'age') choice(2, 'name', 'How old is ' + (name || 'your kid') + '?', 'tpc-choices--2',
      [{ v: '2-3', t: '2–3' }, { v: '4-6', t: '4–6' }, { v: '7-9', t: '7–9' }, { v: 'class', t: "It's for my classroom" }],
      function (v) { Q.age = v; stepB('moment'); });
    if (s === 'moment') choice(3, 'age', "What's the trickiest moment of the day?", '',
      [{ v: 'bed', t: 'Bedtime wind-down', s: 'Lights out turns into an hour of negotiations' }, { v: 'feel', t: 'Big feelings', s: 'Meltdowns that need a way back to calm' }, { v: 'trans', t: '"Five more minutes!"', s: 'Leaving the playground, ending screen time' }, { v: 'focus', t: 'Staying on task', s: 'Homework, reading, piano practice' }],
      function (v) { Q.moment = v; stepB('animal'); });
    if (s === 'animal') choice(4, 'moment', 'Which friend would ' + (name || 'they') + ' hug first?', 'tpc-choices--2',
      b.animals.map(function (a) { return { v: a.key, t: a.name, img: a.img }; }),
      function (v) { Q.animal = v; stepB('email'); });
    if (s === 'email') {
      var pre = resolve(); if (pre && pre.product.img) { var pi = new Image(); pi.src = pre.product.img; }
      card('<div class="tpc-pb tpc-pb--top"><div class="tpc-eyebrow">Your match is ready</div><h2 class="tpc-pt">Where should we send ' + (name ? name + "'s" : 'your') + ' <u>' + esc(b.offer) + '</u>?</h2>' +
        '<form id="tpc-fe" novalidate style="display:flex;flex-direction:column;gap:10px"><input class="tpc-inp" id="tpc-b-email" type="email" autocomplete="email" placeholder="Enter your email address" aria-label="Email address" required><p class="tpc-err" id="tpc-b-err" hidden>Please enter a valid email address.</p><button class="tpc-btn tpc-btn--full" type="submit">Reveal my Pal</button></form>' +
        '<button class="tpc-skip" type="button" id="tpc-sk">No thanks, just show my match</button><p class="tpc-fine">' + esc(CFG.fine) + '</p></div>');
      $('#tpc-fe', ov).onsubmit = function (e) {
        e.preventDefault();
        var input = $('#tpc-b-email', ov);
        if (!input.checkValidity() || !input.value) { $('#tpc-b-err', ov).hidden = false; input.focus(); return; }
        $('button[type=submit]', ov).disabled = true;
        var tags = ['newsletter', 'quiz', 'moment-' + Q.moment, 'age-' + Q.age];
        subscribe(input.value, tags, { v: 'b', q: { age: Q.age, moment: Q.moment, animal: Q.animal } }).then(function (ok) { if (ok) result(true); });
      };
      $('#tpc-sk', ov).onclick = function () { result(false); };
    }
  }
  function resolve() {
    var list = CFG.b.matches, hit = null;
    for (var i = 0; i < list.length && !hit; i++) {
      var m = list[i];
      if (!m.product || !m.product.available) continue;
      if (m.moment !== Q.moment) continue;
      if (m.age !== 'any' && m.age !== Q.age) continue;
      if (m.animal !== 'any' && m.animal !== Q.animal) continue;
      hit = m;
    }
    return hit;
  }
  function result(withCode) {
    current = 'b';
    var b = CFG.b, m = resolve(), t = b.types[Q.moment] || { type: '', why: '' };
    var name = Q.name ? esc(Q.name) : '';
    if (withCode) ls.set(K.done, '1');
    if (!m) { card('<div class="tpc-pb tpc-pb--top"><h2 class="tpc-pt">Meet all the Pals</h2><p class="tpc-px">Have a look around and pick a favorite.</p><a class="tpc-btn tpc-btn--full" href="/collections/all">See all Pals</a></div>'); return; }
    var animal = (b.animals.filter(function (a) { return a.key === Q.animal; })[0] || {}).name || '';
    var note = m.note ? m.note.replace(/\[pal\]/g, animal.split(' ')[0]) : '';
    var code = withCode ? b.code : '';
    var href = discountUrl(code, m.product.url);
    card('<div class="tpc-conf" id="tpc-conf"></div><div class="tpc-pb tpc-pb--top"><span class="tpc-badge">' + esc(t.type) + '</span>' +
      '<h2 class="tpc-pt">' + (name ? name + "'s" : "Your kid's") + ' Pal is <u>' + esc(m.who || m.product.title) + '</u></h2>' +
      '<a class="tpc-res" href="' + esc(href) + '"><img src="' + esc(m.product.img) + '" alt=""><div><b>' + esc(m.product.title) + ' · ' + esc(m.product.price) + '</b><span>' + esc(t.why) + '</span></div></a>' +
      (note ? '<p class="tpc-note">' + esc(note) + '</p>' : '') +
      (Q.age === 'class' && b.classNote ? '<p class="tpc-note">' + esc(b.classNote) + '</p>' : '') +
      (code ? '<div class="tpc-code"><span>' + esc(code) + '</span><button type="button" data-tpc-copy>Copy code</button></div>' : '') +
      '<a class="tpc-btn tpc-btn--full" href="' + esc(href) + '">' + (code ? 'Shop with ' + esc(b.offer) : 'See this Pal') + ' · ' + esc(m.product.price) + '</a>' +
      '<button class="tpc-skip" type="button" id="tpc-again">Retake the quiz</button></div>');
    copyBtn(code);
    $('#tpc-again', ov).onclick = function () { Q = {}; stepB('intro'); };
    track('tpc_quiz_result', { moment: Q.moment, age: Q.age, animal: Q.animal, product: m.product.handle, subscribed: !!withCode });
    if (!reduced) {
      var box = $('#tpc-conf', ov), cols = ['#ffd265', '#547ab8', '#cbb8f5', '#8fd9c4'];
      for (var i = 0; i < 18; i++) {
        var sz = 12 + Math.random() * 12;
        box.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" width="' + sz + '" height="' + sz + '" style="left:' + (Math.random() * 94) + '%;animation-delay:' + (Math.random() * 0.9) + 's"><path fill="' + cols[i % 4] + '" d="M12 2l2.9 6.6 7.1.7-5.4 4.8 1.6 7L12 17.4 5.8 21l1.6-7L2 9.3l7.1-.7z"/></svg>');
      }
      setTimeout(function () { if (box) box.innerHTML = ''; }, 3800);
    }
  }

  function initPopups() {
    if (!CFG) return;
    /* Any "Find your Pal" button or #find-your-pal link opens the quiz, even when the timed popup is off. */
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-tpc-quiz],a[href$="#find-your-pal"]') : null;
      if (t) { e.preventDefault(); openB(); }
    });
    if (CFG.designMode) {
      document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === CFG.sectionId) { CFG.preview === 'a' ? openA() : openB(); } });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === CFG.sectionId) closePop(false); });
      return;
    }
    /* Testing aid: add ?tpc_popup=a or ?tpc_popup=b to any URL to open that popup straight away. */
    var force = null;
    try { force = new URLSearchParams(window.location.search).get('tpc_popup'); } catch (e) {}
    if (force === 'a') { openA(); return; }
    if (force === 'b') { openB(); return; }
    /* Resume after a full-page form post (captcha fallback). */
    var pending = ls.get(K.pending);
    if (pending) {
      ls.del(K.pending);
      try { var p = JSON.parse(pending); if (p.v === 'a') { successA(); return; } if (p.v === 'b' && p.q) { Q = p.q; result(true); return; } } catch (e) {}
    }
    if (!CFG.enabled || CFG.blocked) return;
    if (ls.get(K.done)) return;
    var closedAt = parseInt(ls.get(K.closed) || '0', 10);
    if (closedAt && Date.now() - closedAt < CFG.snoozeDays * 864e5) { if (ls.get(K.variant) === 'b' && CFG.teaser) { current = 'b'; showTeaser(); } return; }
    var v = ls.get(K.variant);
    if (v !== 'a' && v !== 'b') { v = Math.random() * 100 < CFG.splitB ? 'b' : 'a'; ls.set(K.variant, v); }
    var fired = false;
    function fire() { if (fired || (ov && !ov.hidden)) return; fired = true; window.removeEventListener('scroll', onScroll); v === 'a' ? openA() : openB(); }
    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h * 100 >= CFG.scroll) fire();
    }
    setTimeout(fire, CFG.delay * 1000);
    if (CFG.scroll > 0) window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* =====================================================================
     2. Glow: tap a Pal to cycle its colour (hero + "colors" demo)
     ===================================================================== */
  var HUES = [0, 300, 215, 160, 120, 95, 60, 30];
  function hsl(d) { return 'hsl(' + ((265 + d) % 360) + ' 85% 76%)'; }
  function initGlow(root) {
    var btn = $('.tpc-glow', root); if (!btn || btn.__tpc) return; btn.__tpc = true;
    var img = $('img', btn), halo = $('.tpc-glow__halo', btn), dots = $('.tpc-dots', root), i = 0;
    if (dots) HUES.forEach(function (d) { var s = document.createElement('span'); s.style.background = hsl(d); dots.appendChild(s); });
    function paint() {
      var d = HUES[i];
      if (!btn.dataset.nofilter) img.style.filter = 'hue-rotate(' + d + 'deg) saturate(1.25)';
      halo.style.setProperty('--tpc-halo', hsl(d));
      if (dots) $$('span', dots).forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
    }
    btn.addEventListener('click', function () { i = (i + 1) % HUES.length; paint(); });
    paint();
  }

  /* =====================================================================
     3. Try-it demos: breathing pacer / visual timer
     ===================================================================== */
  var PATTERNS = {
    '478': [['Breathe in', 4, 1], ['Hold', 7, 1], ['Breathe out', 8, 0]],
    'box': [['Breathe in', 4, 1], ['Hold', 4, 1], ['Breathe out', 4, 0], ['Hold', 4, 0]],
    '55': [['Breathe in', 5, 1], ['Breathe out', 5, 0]]
  };
  function initBreath(root) {
    var halo = $('.tpc-orb__halo', root), img = $('.tpc-orb img', root), ph = $('.tpc-try__phase', root), ct = $('.tpc-try__count', root), btn = $('[data-tpc-toggle]', root);
    if (!btn || btn.__tpc) return; btn.__tpc = true;
    var idle = ct.textContent, mode = root.dataset.mode || '478', timer = null, tick = null, running = false;
    function set(up, secs) {
      [halo, img].forEach(function (el) { if (el) el.style.transitionDuration = secs + 's'; });
      halo.style.opacity = up ? 0.95 : 0.3; halo.style.transform = 'scale(' + (up ? 1.12 : 0.8) + ')';
      if (img) img.style.transform = 'scale(' + (up ? 1.06 : 0.92) + ')';
    }
    function run(i) {
      var p = PATTERNS[mode] || PATTERNS['478'], step = p[i % p.length], left = step[1];
      ph.textContent = step[0]; ct.textContent = left + ' s'; set(step[2], step[0] === 'Hold' ? 0.2 : step[1]);
      tick = setInterval(function () { left--; if (left > 0) ct.textContent = left + ' s'; }, 1000);
      timer = setTimeout(function () { clearInterval(tick); run(i + 1); }, step[1] * 1000);
    }
    function stop() { running = false; clearTimeout(timer); clearInterval(tick); set(0, 0.6); ph.textContent = root.dataset.ready || 'Ready?'; ct.textContent = idle; btn.textContent = 'Start'; }
    btn.addEventListener('click', function () { if (running) return stop(); running = true; btn.textContent = 'Stop'; run(0); });
    $$('[data-tpc-mode]', root).forEach(function (m) {
      m.addEventListener('click', function () {
        mode = m.dataset.tpcMode;
        $$('[data-tpc-mode]', root).forEach(function (x) { x.classList.toggle('is-on', x === m); });
        if (running) { clearTimeout(timer); clearInterval(tick); run(0); }
      });
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden && running) stop(); });
  }
  function initTimer(root) {
    var btn = $('[data-tpc-toggle]', root); if (!btn || btn.__tpc) return; btn.__tpc = true;
    var ph = $('.tpc-try__phase', root), ct = $('.tpc-try__count', root), disc = $('.tpc-orb__disc', root), arcs = $$('[data-tpc-arc]', root);
    var phases = (root.dataset.phases || '').split(';').map(function (s) { var p = s.split('|'); return { at: parseFloat(p[0]), color: p[1], label: p[2] }; }).filter(function (p) { return p.color; });
    var total = parseFloat(root.dataset.seconds || '20'), minutes = parseFloat(root.dataset.minutes || '10');
    var idle = ct.textContent, raf = null, t0 = 0, running = false;
    function paint(pct) {
      var cur = phases[0], idx = 0;
      phases.forEach(function (p, n) { if (pct >= p.at) { cur = p; idx = n; } });
      if (disc) { disc.style.setProperty('--tpc-orb', cur.color); var left = Math.max(0, Math.round(minutes * 60 * (1 - pct / 100))); disc.textContent = ('0' + Math.floor(left / 60)).slice(-2) + ':' + ('0' + (left % 60)).slice(-2); }
      arcs.forEach(function (a, n) { a.style.opacity = n <= idx ? 1 : 0.16; });
      ph.textContent = cur.label;
      ct.textContent = Math.round(100 - pct) + '% of the time left';
    }
    function reset() { running = false; cancelAnimationFrame(raf); btn.textContent = 'Start'; ph.textContent = root.dataset.ready || 'Ready?'; ct.textContent = idle; if (disc) { disc.style.setProperty('--tpc-orb', phases[0] ? phases[0].color : '#6db8ff'); disc.textContent = ('0' + minutes).slice(-2) + ':00'; } arcs.forEach(function (a) { a.style.opacity = 0.16; }); }
    function frame(now) {
      var pct = Math.min(100, (now - t0) / (total * 1000) * 100);
      paint(pct);
      if (pct < 100) { raf = requestAnimationFrame(frame); return; }
      ph.textContent = root.dataset.done || "Time's up!"; ct.textContent = ''; arcs.forEach(function (a) { a.style.opacity = 1; });
      setTimeout(function () { if (running) reset(); }, 2600);
    }
    btn.addEventListener('click', function () { if (running) return reset(); running = true; btn.textContent = 'Reset'; t0 = performance.now(); raf = requestAnimationFrame(frame); });
    reset();
  }

  /* =====================================================================
     4. Pal day: add the set to cart
     ===================================================================== */
  function initDay(root) {
    var btn = $('[data-tpc-add-set]', root); if (!btn || btn.__tpc) return; btn.__tpc = true;
    btn.addEventListener('click', function () {
      var ids = (btn.dataset.tpcAddSet || '').split(',').filter(Boolean);
      if (!ids.length) return;
      btn.disabled = true; var label = btn.textContent; btn.textContent = 'Adding…';
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; btn.textContent = label; alert('Sorry, we could not add these to your cart. Please add them one at a time.'); });
    });
  }

  function boot(scope) {
    $$('[data-tpc="glow"]', scope).forEach(initGlow);
    $$('[data-tpc="breath"]', scope).forEach(initBreath);
    $$('[data-tpc="timer"]', scope).forEach(initTimer);
    $$('[data-tpc="day"]', scope).forEach(initDay);
  }
  function start() { boot(document); initPopups(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
